/**
 * @generated SignedSource<<ba2064330c59e65c269fd13fd12f5ea7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type JobsListing_User$data = {
  readonly configuration: {
    readonly enableCompanyVideos: boolean | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "JobsListing_User";
};
export type JobsListing_User$key = {
  readonly " $data"?: JobsListing_User$data;
  readonly " $fragmentSpreads": FragmentRefs<"JobsListing_User">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "JobsListing_User",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Configuration",
      "kind": "LinkedField",
      "name": "configuration",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "enableCompanyVideos",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "fe3dd68d019cdf0d05747adc3201402f";

export default node;
